<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            type="search"
            name="deptCd"
            label="관리부서"
            v-model="searchParam.deptCd"
          ></c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-table
          title="장소 목록"
          :columns="grid.columns"
          :data="grid.data"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- 검색 -->
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <q-form ref="editForm">
          <!-- 상세 -->
          <c-card title="LBLDETAIL" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <!-- 등록 -->
                <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="addData" />
                <!-- 저장 -->
                <c-btn
                  v-if="inputEditable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="location"
                  :mappingType="saveType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!-- 위치정보 -->
                <c-text
                  :required="true"
                  :editable="inputEditable"
                  label="장소명"
                  name="locationName"
                  v-model="location.locationName">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-dept
                  type="edit"
                  :editable="inputEditable"
                  :required="true"
                  name="deptCd"
                  label="관리부서"
                  v-model="location.deptCd"
                ></c-dept>
              </div>
              <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-location
                  type="edit"
                  :editable="inputEditable"
                  label="상위 장소"
                  nodateLabel="최상위장소"
                  name="upMdmLocationId"
                  multiple="single"
                  v-model="location.upMdmLocationId">
                >
                </c-location>
              </div> -->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <!-- 비고 -->
                <c-textarea
                  :editable="inputEditable"
                  :rows="4"
                  label="비고"
                  name="remarks"
                  v-model="location.remarks">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-plant
                  :required="true"
                  :editable="inputEditable"
                  type="edit"
                  name="plantCd"
                  v-model="location.plantCd"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-checkbox
                  :editable="inputEditable"
                  :isFlag="true"
                  label="사용여부"
                  name="useFlag"
                  v-model="location.useFlag"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!-- 정렬순서 -->
                <c-text
                  :editable="inputEditable"
                  type="number"
                  label="정렬순서"
                  name="sortOrder"
                  v-model="location.sortOrder">
                </c-text>
              </div>
            </template>
          </c-card>
        </q-form>
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'locationManage',
  data() {
    return {
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
        deptCd: '',
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
            style: 'width:120px'
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '관리부서',
            align: 'center',
            sortable: false,
            style: 'width: 140px',
          },
          {
            name: 'locationName',
            field: 'locationName',
            label: '장소명',
            align: 'left',
            sortable: true,
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '정렬순서',
            align: 'center',
            sortable: true,
            style: 'width:80px'
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            sortable: true,
            style: 'width:80px',
          },
        ],
        data: [],
      },
      location: {
        mdmLocationId: '',
        plantCd: null,
        deptCd: '',
        locationName: '',
        upMdmLocationId: '',
        remarks: '',
        useFlag: 'Y',
        sortOrder: null,
        regUserId: '',
        chgUserId: '',
      },
      useItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      isModify: false,
      editable: true,
      isSave: false,
      listUrl: '',
      detailUrl: '',
      saveUrl: '',
      saveType: 'POST',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    inputEditable() {
      return this.isModify && this.editable;
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.location.list.url;
      this.detailUrl = selectConfig.mdm.location.get.url;
      this.saveUrl = transactionConfig.mdm.location.insert.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    rowClick(row) {
      // 상세조회
      this.$http.url = this.$format(this.detailUrl, row.mdmLocationId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.$_.extend(this.location, _result.data);
        if (this.location.mdmLocationId !== 'ETC') {
          this.isModify = true;
        }
      },);
    },
    addData() {
      Object.assign(this.$data.location, this.$options.data().location);
      this.isModify = true;
      this.location.plantCd = this.searchParam.plantCd;
    },
    saveData() {
      if (this.location.mdmLocationId) {
        this.saveUrl = transactionConfig.mdm.location.update.url;
        this.saveType = 'PUT'
      } else {
        this.saveUrl = transactionConfig.mdm.location.insert.url;
        this.saveType = 'POST'
      }

      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.location.regUserId = this.$store.getters.user.userId 
              this.location.chgUserId = this.$store.getters.user.userId 

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
      this.rowClick({ mdmLocationId: result.data })
    },
  }
};
</script>
